@if(showLoader){
  <div class="showLoader">
    <mat-progress-spinner
      color="primary"
      mode="indeterminate"
      diameter="50"
    ></mat-progress-spinner>
  </div>
} @else{
  @if (loggedIn) {
    <div>
      <app-header [validUser]="validUser"></app-header>
      @if(validUser){
        <router-outlet></router-outlet>
        } @if(invalidUser){
        <div class="noAccess-txt">
          <img class="denied-img" src="./../assets/access-denied.jpg" />
          <h1 class="noAccess">{{ applicationConst.noAccess }}</h1>
          <h5 class="noAccess">{{ applicationConst.noPermission }}</h5>
        </div>
      }
    </div>
  }
}
